import type { SVGProps } from "react";

/**
 * Isotipo — el monograma "a/@" solo — favicon, app icon, marca de agua. Funciona sin el resto del wordmark.
 *
 * Trazado vectorial único (idéntico en las 3 variantes de color del manual de
 * marca — `docs/brand/manual-de-marca.md` §3), vectorizado con potrace desde
 * los assets de 2020. `fill` por defecto es `currentColor`: hereda el color
 * de texto CSS del contenedor. Usar los tokens de marca (`--brand`,
 * `--brand-on`, `#fff`, `#000`) vía `style={{ color: ... }}` o className,
 * o los wrappers de color abajo para los tres tonos oficiales.
 */
export function Isotipo(props: SVGProps<SVGSVGElement>) {
  const { fill = "currentColor", ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1112.000000 1616.000000"
      role="img"
      aria-label="WASOM"
      {...rest}
    >
      <g transform="translate(0.000000,1616.000000) scale(0.100000,-0.100000)" fill={fill} stroke="none">
        <path d="M3360 15330 c0 -5 -7 -10 -15 -10 -20 0 -65 -45 -65 -65 0 -8 -4 -15
-10 -15 -6 0 -10 -127 -10 -360 0 -233 4 -360 10 -360 6 0 10 -9 10 -20 0 -11
5 -20 10 -20 6 0 10 -9 10 -20 0 -13 7 -20 20 -20 11 0 20 -4 20 -10 0 -5 9
-10 20 -10 11 0 20 -4 20 -10 0 -7 597 -10 1770 -10 1173 0 1770 -3 1770 -10
0 -6 30 -10 70 -10 40 0 70 -4 70 -10 0 -6 30 -10 70 -10 40 0 70 -4 70 -10 0
-5 23 -10 50 -10 28 0 50 -4 50 -10 0 -5 23 -10 50 -10 28 0 50 -4 50 -10 0
-5 18 -10 40 -10 22 0 40 -4 40 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0
-5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0
-5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0
-5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5
9 -10 20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 8
-10 18 -10 10 0 24 -9 32 -20 8 -11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 8
-10 18 -10 10 0 24 -9 32 -20 8 -11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 7
-10 16 -10 9 0 29 -13 44 -30 15 -16 34 -30 42 -30 7 0 20 -9 28 -20 8 -11 21
-20 28 -20 8 0 27 -13 42 -30 15 -16 33 -30 39 -30 15 0 361 -346 361 -361 0
-6 14 -24 30 -39 17 -15 30 -33 30 -40 0 -7 14 -25 30 -40 17 -15 30 -34 30
-42 0 -7 9 -20 20 -28 11 -8 20 -21 20 -30 0 -9 9 -22 20 -30 11 -8 20 -22 20
-32 0 -10 5 -18 10 -18 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20
0 -11 5 -20 10 -20 6 0 10 -8 10 -18 0 -10 9 -24 20 -32 11 -8 20 -22 20 -32
0 -10 5 -18 10 -18 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -9 10 -20 0
-11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0
-16 5 -30 10 -30 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0
-16 5 -30 10 -30 6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -13 10 -30 0
-16 5 -30 10 -30 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -22 10 -50 0
-27 5 -50 10 -50 6 0 10 -22 10 -50 0 -27 5 -50 10 -50 6 0 10 -22 10 -50 0
-27 5 -50 10 -50 6 0 10 -33 10 -80 0 -47 4 -80 10 -80 6 0 10 -67 10 -180 0
-113 4 -180 10 -180 7 0 10 -1203 10 -3590 0 -2387 -3 -3590 -10 -3590 -6 0
-10 -63 -10 -170 0 -107 -4 -170 -10 -170 -6 0 -10 -37 -10 -90 0 -53 -4 -90
-10 -90 -6 0 -10 -27 -10 -60 0 -33 -4 -60 -10 -60 -5 0 -10 -18 -10 -40 0
-22 -4 -40 -10 -40 -5 0 -10 -22 -10 -50 0 -27 -4 -50 -10 -50 -5 0 -10 -18
-10 -40 0 -22 -4 -40 -10 -40 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0
-10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10
-30 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -9 -10 -20 0 -11 -4
-20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10 -30 0
-16 -4 -30 -10 -30 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10
-20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10
-8 -10 -18 0 -10 -9 -24 -20 -32 -11 -8 -20 -22 -20 -32 0 -10 -4 -18 -10 -18
-5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -8 -10 -18 0 -10 -9 -24
-20 -32 -11 -8 -20 -21 -20 -28 0 -8 -13 -27 -30 -42 -16 -15 -30 -34 -30 -42
0 -7 -9 -20 -20 -28 -11 -8 -20 -20 -20 -28 0 -7 -27 -40 -60 -72 -33 -32 -60
-64 -60 -70 0 -14 -166 -180 -180 -180 -6 0 -38 -27 -70 -60 -32 -33 -64 -60
-70 -60 -7 0 -25 -14 -40 -30 -15 -17 -33 -30 -40 -30 -7 0 -25 -13 -40 -30
-15 -16 -35 -30 -44 -30 -9 0 -16 -4 -16 -10 0 -5 -8 -10 -18 -10 -10 0 -24
-9 -32 -20 -8 -11 -22 -20 -32 -20 -10 0 -18 -4 -18 -10 0 -5 -9 -10 -20 -10
-11 0 -20 -4 -20 -10 0 -5 -8 -10 -18 -10 -10 0 -24 -9 -32 -20 -8 -11 -22
-20 -32 -20 -10 0 -18 -4 -18 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10
0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4
-20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -13 -10 -30 -10 -16 0
-30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30
-10 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -18
-10 -40 -10 -22 0 -40 -4 -40 -10 0 -5 -18 -10 -40 -10 -22 0 -40 -4 -40 -10
0 -5 -22 -10 -50 -10 -27 0 -50 -4 -50 -10 0 -6 -27 -10 -60 -10 -33 0 -60 -4
-60 -10 0 -6 -30 -10 -70 -10 -40 0 -70 -4 -70 -10 0 -6 -70 -10 -190 -10
-120 0 -190 -4 -190 -10 0 -7 -357 -10 -1050 -10 -693 0 -1050 3 -1050 10 0 6
-67 10 -180 10 -113 0 -180 4 -180 10 0 6 -33 10 -80 10 -47 0 -80 4 -80 10 0
6 -27 10 -60 10 -33 0 -60 4 -60 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6
-22 10 -50 10 -27 0 -50 5 -50 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6
-13 10 -30 10 -16 0 -30 5 -30 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6
-13 10 -30 10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6
-13 10 -30 10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9
10 -20 10 -11 0 -20 5 -20 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -8 10
-18 10 -10 0 -24 9 -32 20 -8 11 -22 20 -32 20 -10 0 -18 5 -18 10 0 6 -8 10
-18 10 -10 0 -24 9 -32 20 -8 11 -22 20 -32 20 -10 0 -18 5 -18 10 0 6 -8 10
-18 10 -10 0 -24 9 -32 20 -8 11 -21 20 -28 20 -8 0 -27 13 -42 30 -15 16 -34
30 -42 30 -7 0 -20 9 -28 20 -8 11 -20 20 -28 20 -7 0 -44 32 -82 70 -38 39
-74 70 -80 70 -14 0 -140 126 -140 140 0 6 -27 38 -60 70 -33 32 -60 64 -60
70 0 7 -14 25 -30 40 -17 15 -30 34 -30 42 0 7 -9 20 -20 28 -11 8 -20 21 -20
28 0 8 -13 27 -30 42 -17 15 -30 35 -30 44 0 9 -4 16 -10 16 -5 0 -10 9 -10
20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 8 -10 18
0 10 -9 24 -20 32 -11 8 -20 22 -20 32 0 10 -4 18 -10 18 -5 0 -10 9 -10 20 0
11 -4 20 -10 20 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 9 -10 20 0 11
-4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 14 -10 30 0 17 -4
30 -10 30 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 14 -10 30 0 17 -4 30
-10 30 -5 0 -10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 14 -10 30 0 17 -4 30
-10 30 -5 0 -10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 18 -10 40 0 22 -4 40
-10 40 -5 0 -10 23 -10 50 0 28 -4 50 -10 50 -6 0 -10 27 -10 60 0 33 -4 60
-10 60 -6 0 -10 37 -10 90 0 53 -4 90 -10 90 -7 0 -10 827 -10 2460 0 1633 3
2460 10 2460 6 0 10 33 10 80 0 47 4 80 10 80 6 0 10 27 10 60 0 33 4 60 10
60 6 0 10 23 10 50 0 28 5 50 10 50 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10
18 10 40 0 22 5 40 10 40 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 14 10 30 0
17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10
30 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 9
10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5
20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0
10 8 10 18 0 10 9 24 20 32 11 8 20 22 20 32 0 10 5 18 10 18 6 0 10 8 10 18
0 10 9 24 20 32 11 8 20 21 20 28 0 8 14 27 30 42 17 15 30 33 30 40 0 7 14
25 30 40 17 15 30 33 30 39 0 7 36 47 80 91 44 44 80 84 80 90 0 15 25 40 40
40 6 0 42 32 80 70 38 39 74 70 81 70 6 0 24 14 39 30 15 17 33 30 40 30 7 0
25 14 40 30 15 17 34 30 42 30 7 0 20 9 28 20 8 11 22 20 32 20 10 0 18 5 18
10 0 6 8 10 18 10 10 0 24 9 32 20 8 11 22 20 32 20 10 0 18 5 18 10 0 6 9 10
20 10 11 0 20 5 20 10 0 6 8 10 18 10 10 0 24 9 32 20 8 12 26 20 42 20 15 0
28 5 28 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0
6 9 10 20 10 11 0 20 5 20 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 9 10 20 10
11 0 20 5 20 10 0 6 18 10 40 10 22 0 40 5 40 10 0 6 14 10 30 10 17 0 30 5
30 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 18 10 40 10 22 0 40 5 40 10 0 6
18 10 40 10 22 0 40 5 40 10 0 6 23 10 50 10 28 0 50 5 50 10 0 6 27 10 60 10
33 0 60 4 60 10 0 6 33 10 80 10 47 0 80 4 80 10 0 7 267 10 780 10 513 0 780
-3 780 -10 0 -6 27 -10 60 -10 33 0 60 -4 60 -10 0 -5 23 -10 50 -10 28 0 50
-4 50 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 14 -10 30 -10 17 0 30
-4 30 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 9 -10 20 -10 11 0 20 -4
20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20
-10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 8 -10 18 -10 10 0 24 -9 32 -20
8 -11 21 -20 28 -20 8 0 27 -13 42 -30 15 -16 33 -30 39 -30 16 0 241 -227
241 -243 0 -7 9 -19 20 -27 11 -8 20 -21 20 -30 0 -9 9 -22 20 -30 11 -8 20
-22 20 -32 0 -10 5 -18 10 -18 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9
10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10
-20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -18 10
-40 0 -22 5 -40 10 -40 6 0 10 -22 10 -50 0 -27 5 -50 10 -50 6 0 10 -40 10
-100 0 -60 4 -100 10 -100 7 0 10 -187 10 -540 l0 -540 -880 0 c-580 0 -880
-3 -880 -10 0 -6 -30 -10 -70 -10 -40 0 -70 -4 -70 -10 0 -6 -30 -10 -70 -10
-40 0 -70 -4 -70 -10 0 -5 -22 -10 -50 -10 -27 0 -50 -4 -50 -10 0 -5 -18 -10
-40 -10 -22 0 -40 -4 -40 -10 0 -5 -18 -10 -40 -10 -22 0 -40 -4 -40 -10 0 -5
-13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30
-10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0
-30 -4 -30 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10
-11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10
-20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5
-8 -10 -18 -10 -10 0 -24 -9 -32 -20 -8 -11 -22 -20 -32 -20 -10 0 -18 -4 -18
-10 0 -5 -8 -10 -18 -10 -10 0 -24 -9 -32 -20 -8 -11 -21 -20 -28 -20 -8 0
-27 -14 -42 -30 -15 -16 -34 -30 -42 -30 -7 0 -20 -9 -28 -20 -8 -11 -20 -20
-28 -20 -7 0 -48 -36 -92 -80 -44 -44 -84 -80 -90 -80 -14 0 -60 -46 -60 -60
0 -6 -27 -38 -60 -70 -33 -32 -60 -64 -60 -70 0 -7 -13 -25 -30 -40 -16 -15
-30 -34 -30 -42 0 -7 -9 -20 -20 -28 -11 -8 -20 -21 -20 -30 0 -9 -9 -22 -20
-30 -11 -8 -20 -21 -20 -30 0 -9 -9 -22 -20 -30 -11 -8 -20 -22 -20 -32 0 -10
-4 -18 -10 -18 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20
0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9
-10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0
-10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10
-30 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10 -30 0 -16 -4
-30 -10 -30 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -13 -10 -30
0 -16 -4 -30 -10 -30 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -22
-10 -50 0 -27 -4 -50 -10 -50 -5 0 -10 -18 -10 -40 0 -22 -4 -40 -10 -40 -5 0
-10 -22 -10 -50 0 -27 -4 -50 -10 -50 -6 0 -10 -33 -10 -80 0 -47 -4 -80 -10
-80 -6 0 -10 -47 -10 -120 0 -73 -4 -120 -10 -120 -6 0 -10 -67 -10 -180 0
-113 4 -180 10 -180 6 0 10 -43 10 -110 0 -67 4 -110 10 -110 6 0 10 -30 10
-70 0 -40 4 -70 10 -70 6 0 10 -22 10 -50 0 -27 5 -50 10 -50 6 0 10 -22 10
-50 0 -27 5 -50 10 -50 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -18 10
-40 0 -22 5 -40 10 -40 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20
0 -11 5 -20 10 -20 6 0 10 -13 10 -28 0 -16 8 -34 20 -42 11 -8 20 -22 20 -32
0 -10 5 -18 10 -18 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -8 10 -18 0
-10 9 -24 20 -32 11 -8 20 -22 20 -32 0 -10 5 -18 10 -18 6 0 10 -7 10 -16 0
-9 13 -29 30 -44 16 -15 30 -33 30 -40 0 -7 13 -25 30 -40 16 -15 30 -33 30
-39 0 -7 31 -43 70 -81 38 -38 70 -74 70 -80 0 -14 66 -80 80 -80 6 0 42 -31
80 -70 38 -38 75 -70 82 -70 8 0 20 -9 28 -20 8 -11 21 -20 28 -20 8 0 27 -13
42 -30 15 -16 34 -30 42 -30 7 0 20 -9 28 -20 8 -11 22 -20 32 -20 10 0 18 -4
18 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 8 -10 18 -10 10 0 24 -9 32
-20 8 -11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 9 -10 20 -10 11 0 20 -4 20
-10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30
-10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10
0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0
-5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 18 -10 40 -10 22 0 40 -4 40 -10 0
-5 18 -10 40 -10 22 0 40 -4 40 -10 0 -5 18 -10 40 -10 22 0 40 -4 40 -10 0
-5 23 -10 50 -10 28 0 50 -4 50 -10 0 -6 30 -10 70 -10 40 0 70 -4 70 -10 0
-6 53 -10 140 -10 87 0 140 -4 140 -10 0 -6 43 -10 110 -10 67 0 110 4 110 10
0 6 53 10 140 10 87 0 140 4 140 10 0 6 33 10 80 10 47 0 80 4 80 10 0 6 18
10 40 10 22 0 40 5 40 10 0 6 23 10 50 10 28 0 50 5 50 10 0 6 18 10 40 10 22
0 40 5 40 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 18 10 40 10 22 0 40 5 40
10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10
20 10 11 0 20 5 20 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 9 10 20 10 11 0
20 5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0
6 9 10 20 10 11 0 20 5 20 10 0 6 8 10 18 10 10 0 24 9 32 20 8 11 21 20 30
20 9 0 22 9 30 20 8 11 21 20 30 20 9 0 22 9 30 20 8 11 21 20 30 20 9 0 22 9
30 20 8 11 20 20 28 20 7 0 40 27 72 60 32 33 64 60 70 60 14 0 160 146 160
160 0 6 23 33 50 60 28 27 50 54 50 60 0 7 14 25 30 40 17 15 30 34 30 42 0 7
9 20 20 28 11 8 20 22 20 32 0 10 5 18 10 18 6 0 10 9 10 20 0 11 5 20 10 20
6 0 10 8 10 18 0 10 9 24 20 32 11 8 20 22 20 32 0 10 5 18 10 18 6 0 10 9 10
20 0 11 5 20 10 20 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 9 10 20 0 11 5 20
10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10
14 10 30 0 17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 14 10 30 0
17 5 30 10 30 6 0 10 23 10 50 0 28 5 50 10 50 6 0 10 18 10 40 0 22 5 40 10
40 6 0 10 33 10 80 0 47 4 80 10 80 6 0 10 50 10 130 0 80 4 130 10 130 7 0
10 667 10 1980 0 1313 -3 1980 -10 1980 -6 0 -10 53 -10 140 0 87 -4 140 -10
140 -6 0 -10 33 -10 80 0 47 -4 80 -10 80 -5 0 -10 23 -10 50 0 28 -4 50 -10
50 -5 0 -10 23 -10 50 0 28 -4 50 -10 50 -5 0 -10 18 -10 40 0 22 -4 40 -10
40 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17 -4 30 -10
30 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17 -4 30 -10
30 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20
-5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5
0 -10 8 -10 18 0 10 -9 24 -20 32 -11 8 -20 22 -20 32 0 10 -4 18 -10 18 -5 0
-10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 8 -10 18 0 10 -9 24 -20 32 -11 8
-20 21 -20 28 0 8 -13 27 -30 42 -16 15 -30 34 -30 42 0 7 -9 20 -20 28 -11 8
-20 20 -20 28 0 7 -36 48 -80 92 -44 44 -80 84 -80 90 0 15 -25 40 -40 40 -6
0 -42 32 -80 70 -38 39 -74 70 -81 70 -6 0 -24 14 -39 30 -15 17 -34 30 -42
30 -7 0 -20 9 -28 20 -8 11 -21 20 -30 20 -9 0 -22 9 -30 20 -8 11 -21 20 -30
20 -9 0 -22 9 -30 20 -8 11 -22 20 -32 20 -10 0 -18 5 -18 10 0 6 -8 10 -18
10 -10 0 -24 9 -32 20 -8 11 -22 20 -32 20 -10 0 -18 5 -18 10 0 6 -13 10 -30
10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10
-11 0 -20 5 -20 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10
-11 0 -20 5 -20 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6 -13 10 -30 10
-16 0 -30 5 -30 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -18 10 -40 10
-22 0 -40 5 -40 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6 -22 10 -50 10
-27 0 -50 5 -50 10 0 6 -37 10 -90 10 -53 0 -90 4 -90 10 0 7 -303 10 -890 10
-587 0 -890 -3 -890 -10 0 -6 -37 -10 -90 -10 -53 0 -90 -4 -90 -10 0 -6 -30
-10 -70 -10 -40 0 -70 -4 -70 -10 0 -5 -22 -10 -50 -10 -27 0 -50 -4 -50 -10
0 -5 -22 -10 -50 -10 -27 0 -50 -4 -50 -10 0 -5 -22 -10 -50 -10 -27 0 -50 -4
-50 -10 0 -5 -18 -10 -40 -10 -22 0 -40 -4 -40 -10 0 -5 -18 -10 -40 -10 -22
0 -40 -4 -40 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30
-10 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -13
-10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10
0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4
-30 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0
-20 -4 -20 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -9 -10 -20
-10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9
-10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0
-5 -8 -10 -18 -10 -10 0 -24 -9 -32 -20 -8 -11 -22 -20 -32 -20 -10 0 -18 -4
-18 -10 0 -5 -8 -10 -18 -10 -10 0 -24 -9 -32 -20 -8 -11 -22 -20 -32 -20 -10
0 -18 -4 -18 -10 0 -5 -8 -10 -18 -10 -10 0 -24 -9 -32 -20 -8 -11 -21 -20
-30 -20 -9 0 -22 -9 -30 -20 -8 -11 -21 -20 -28 -20 -8 0 -27 -13 -42 -30 -15
-16 -33 -30 -40 -30 -6 0 -29 -18 -50 -40 -21 -22 -44 -40 -50 -40 -6 0 -33
-22 -60 -50 -27 -27 -54 -50 -59 -50 -14 0 -281 -267 -281 -281 0 -5 -22 -32
-50 -59 -27 -27 -50 -54 -50 -60 0 -6 -18 -29 -40 -50 -22 -21 -40 -44 -40
-50 0 -7 -13 -25 -30 -40 -16 -15 -30 -34 -30 -42 0 -7 -9 -20 -20 -28 -11 -8
-20 -21 -20 -30 0 -9 -9 -22 -20 -30 -11 -8 -20 -22 -20 -32 0 -10 -4 -18 -10
-18 -5 0 -10 -8 -10 -18 0 -10 -9 -24 -20 -32 -11 -8 -20 -22 -20 -32 0 -10
-4 -18 -10 -18 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -8 -10 -18
0 -10 -9 -24 -20 -32 -11 -8 -20 -22 -20 -32 0 -10 -4 -18 -10 -18 -5 0 -10
-9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30
-5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20
-10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10 -30 0 -16
-4 -30 -10 -30 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10
-30 0 -16 -4 -30 -10 -30 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10
-13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30
-5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -18 -10 -40 0 -22 -4 -40
-10 -40 -5 0 -10 -18 -10 -40 0 -22 -4 -40 -10 -40 -5 0 -10 -18 -10 -40 0
-22 -4 -40 -10 -40 -5 0 -10 -22 -10 -50 0 -27 -4 -50 -10 -50 -6 0 -10 -27
-10 -60 0 -33 -4 -60 -10 -60 -6 0 -10 -30 -10 -70 0 -40 -4 -70 -10 -70 -6 0
-10 -37 -10 -90 0 -53 -4 -90 -10 -90 -7 0 -10 -850 -10 -2530 0 -1680 3
-2530 10 -2530 6 0 10 -37 10 -90 0 -53 4 -90 10 -90 6 0 10 -30 10 -70 0 -40
4 -70 10 -70 6 0 10 -27 10 -60 0 -33 4 -60 10 -60 6 0 10 -22 10 -50 0 -27 5
-50 10 -50 6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -18 10 -40 0 -22 5
-40 10 -40 6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -13 10 -30 0 -16 5
-30 10 -30 6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -13 10 -30 0 -16 5
-30 10 -30 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0 -16 5
-30 10 -30 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -9 10 -20 0 -11 5
-20 10 -20 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -9 10 -20 0 -11 5
-20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20
10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10
-20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20
6 0 10 -8 10 -18 0 -10 9 -24 20 -32 11 -8 20 -22 20 -32 0 -10 5 -18 10 -18
6 0 10 -8 10 -18 0 -10 9 -24 20 -32 11 -8 20 -21 20 -30 0 -9 9 -22 20 -30
11 -8 20 -21 20 -30 0 -9 9 -22 20 -30 11 -8 20 -21 20 -30 0 -9 9 -22 20 -30
11 -8 20 -21 20 -28 0 -7 18 -31 40 -52 22 -21 40 -44 40 -50 0 -6 18 -29 40
-50 22 -21 40 -43 40 -49 0 -14 346 -361 361 -361 5 0 32 -22 59 -50 27 -27
54 -50 60 -50 7 0 25 -13 40 -30 15 -16 33 -30 40 -30 7 0 25 -13 40 -30 15
-16 34 -30 42 -30 7 0 20 -9 28 -20 8 -11 21 -20 30 -20 9 0 22 -9 30 -20 8
-11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 8 -10 18 -10 10 0 24 -9 32 -20 8
-11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0
-5 8 -10 18 -10 10 0 24 -9 32 -20 8 -11 22 -20 32 -20 10 0 18 -4 18 -10 0
-5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5
9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9
-10 20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 9
-10 20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 14
-10 30 -10 17 0 30 -4 30 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 18
-10 40 -10 22 0 40 -4 40 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 14
-10 30 -10 17 0 30 -4 30 -10 0 -5 18 -10 40 -10 22 0 40 -4 40 -10 0 -5 23
-10 50 -10 28 0 50 -4 50 -10 0 -5 18 -10 40 -10 22 0 40 -4 40 -10 0 -6 27
-10 60 -10 33 0 60 -4 60 -10 0 -6 27 -10 60 -10 33 0 60 -4 60 -10 0 -6 33
-10 80 -10 47 0 80 -4 80 -10 0 -6 60 -10 160 -10 100 0 160 -4 160 -10 0 -7
417 -10 1230 -10 813 0 1230 3 1230 10 0 6 60 10 160 10 100 0 160 4 160 10 0
6 33 10 80 10 47 0 80 4 80 10 0 6 27 10 60 10 33 0 60 4 60 10 0 6 27 10 60
10 33 0 60 4 60 10 0 6 23 10 50 10 28 0 50 5 50 10 0 6 18 10 40 10 22 0 40
5 40 10 0 6 18 10 40 10 22 0 40 5 40 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6
18 10 40 10 22 0 40 5 40 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 14 10 30 10
17 0 30 5 30 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 14 10 30 10 17 0 30 5 30
10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10
20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 14 10 30 10 17 0
30 5 30 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0
6 9 10 20 10 11 0 20 5 20 10 0 6 8 10 18 10 10 0 24 9 32 20 8 11 22 20 32
20 10 0 18 5 18 10 0 6 8 10 18 10 10 0 24 9 32 20 8 11 22 20 32 20 10 0 18
5 18 10 0 6 8 10 18 10 10 0 24 9 32 20 8 11 21 20 30 20 9 0 22 9 30 20 8 11
21 20 28 20 8 0 27 14 42 30 15 17 33 30 40 30 7 0 25 14 40 30 15 17 33 30
40 30 6 0 29 18 50 40 21 22 43 40 49 40 14 0 381 366 381 381 0 5 23 32 50
59 28 27 50 54 50 60 0 7 14 25 30 40 17 15 30 33 30 40 0 7 14 25 30 40 17
15 30 34 30 42 0 7 9 20 20 28 11 8 20 21 20 30 0 9 9 22 20 30 11 8 20 22 20
32 0 10 5 18 10 18 6 0 10 8 10 18 0 10 9 24 20 32 11 8 20 22 20 32 0 10 5
18 10 18 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0
10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0
11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20
6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 9 10
20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 14 10 30 0 17 5 30
10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0
10 14 10 30 0 17 5 30 10 30 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10 14 10 30
0 17 5 30 10 30 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10 23 10 50 0 28 5 50
10 50 6 0 10 23 10 50 0 28 5 50 10 50 6 0 10 23 10 50 0 28 5 50 10 50 6 0
10 30 10 70 0 40 4 70 10 70 6 0 10 37 10 90 0 53 4 90 10 90 6 0 10 80 10
220 0 140 4 220 10 220 7 0 10 1200 10 3580 0 2380 -3 3580 -10 3580 -6 0 -10
77 -10 210 0 133 -4 210 -10 210 -6 0 -10 37 -10 90 0 53 -4 90 -10 90 -6 0
-10 30 -10 70 0 40 -4 70 -10 70 -5 0 -10 23 -10 50 0 28 -4 50 -10 50 -5 0
-10 23 -10 50 0 28 -4 50 -10 50 -5 0 -10 23 -10 50 0 28 -4 50 -10 50 -5 0
-10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0
-10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0
-10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0
-10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0
-10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0
-10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10
9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9
-10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 8 -10
18 0 10 -9 24 -20 32 -11 8 -20 22 -20 32 0 10 -4 18 -10 18 -5 0 -10 9 -10
20 0 11 -4 20 -10 20 -5 0 -10 8 -10 18 0 10 -9 24 -20 32 -11 8 -20 21 -20
30 0 9 -9 22 -20 30 -11 8 -20 21 -20 28 0 8 -13 27 -30 42 -16 15 -30 34 -30
42 0 7 -9 20 -20 28 -11 8 -20 21 -20 28 0 7 -18 31 -40 52 -22 21 -40 44 -40
50 0 6 -27 38 -60 70 -33 32 -60 64 -60 70 0 13 -227 240 -240 240 -6 0 -38
27 -70 60 -32 33 -64 60 -70 60 -6 0 -29 18 -50 40 -21 22 -45 40 -52 40 -7 0
-20 9 -28 20 -8 11 -21 20 -28 20 -8 0 -27 14 -42 30 -15 17 -34 30 -42 30 -7
0 -20 9 -28 20 -8 11 -22 20 -32 20 -10 0 -18 5 -18 10 0 6 -8 10 -18 10 -10
0 -24 9 -32 20 -8 11 -22 20 -32 20 -10 0 -18 5 -18 10 0 6 -9 10 -20 10 -11
0 -20 5 -20 10 0 6 -8 10 -18 10 -10 0 -24 9 -32 20 -8 11 -22 20 -32 20 -10
0 -18 5 -18 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0
-20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -13 10 -30 10 -16 0
-30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20
5 -20 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5
-20 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -13 10 -30 10 -16 0 -30 5
-30 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -13 10 -30 10 -16 0 -30 5
-30 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -18 10 -40 10 -22 0 -40 5
-40 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6 -22 10 -50 10 -27 0 -50 5
-50 10 0 6 -22 10 -50 10 -27 0 -50 5 -50 10 0 6 -27 10 -60 10 -33 0 -60 4
-60 10 0 6 -27 10 -60 10 -33 0 -60 4 -60 10 0 6 -40 10 -100 10 -60 0 -100 4
-100 10 0 7 -617 10 -1830 10 -1213 0 -1830 -3 -1830 -10z m3640 -8300 c0
-653 -3 -990 -10 -990 -6 0 -10 -37 -10 -90 0 -53 -4 -90 -10 -90 -5 0 -10
-18 -10 -40 0 -22 -4 -40 -10 -40 -5 0 -10 -18 -10 -40 0 -22 -4 -40 -10 -40
-5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -9 -10 -20 0 -11 -4 -20
-10 -20 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -8 -10 -18 0 -10
-9 -24 -20 -32 -11 -8 -20 -22 -20 -32 0 -10 -4 -18 -10 -18 -5 0 -10 -8 -10
-18 0 -10 -9 -24 -20 -32 -11 -8 -20 -21 -20 -28 0 -7 -18 -31 -40 -52 -22
-21 -40 -43 -40 -49 0 -15 -86 -101 -101 -101 -6 0 -28 -18 -49 -40 -21 -22
-44 -40 -50 -40 -7 0 -25 -13 -40 -30 -15 -16 -35 -30 -44 -30 -9 0 -16 -4
-16 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0
-20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10
-11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -13 -10
-30 -10 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5
-18 -10 -40 -10 -22 0 -40 -4 -40 -10 0 -5 -18 -10 -40 -10 -22 0 -40 -4 -40
-10 0 -6 -56 -10 -149 -10 -110 0 -151 -3 -155 -12 -5 -10 -7 -10 -12 0 -4 9
-43 12 -145 12 -86 0 -139 4 -139 10 0 6 -22 10 -50 10 -27 0 -50 5 -50 10 0
6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6
-13 10 -30 10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6
-13 10 -30 10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9
10 -20 10 -11 0 -20 5 -20 10 0 6 -8 10 -18 10 -10 0 -24 9 -32 20 -8 11 -22
20 -32 20 -10 0 -18 5 -18 10 0 6 -7 10 -16 10 -9 0 -29 14 -44 30 -15 16 -33
30 -39 30 -15 0 -261 246 -261 261 0 6 -13 24 -30 39 -16 15 -30 34 -30 42 0
7 -9 20 -20 28 -11 8 -20 22 -20 32 0 10 -4 18 -10 18 -5 0 -10 9 -10 20 0 11
-4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4
20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 14 -10 30 0 17 -4 30
-10 30 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17 -4 30
-10 30 -5 0 -10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 23 -10 50 0 28 -4 50
-10 50 -6 0 -10 30 -10 70 0 40 -4 70 -10 70 -6 0 -10 67 -10 180 0 113 4 180
10 180 6 0 10 37 10 90 0 53 4 90 10 90 6 0 10 23 10 50 0 28 5 50 10 50 6 0
10 23 10 50 0 28 5 50 10 50 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 14 10 30
0 17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 9 10 20 0 11 5 20 10
20 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 8
10 18 0 10 9 24 20 32 11 8 20 22 20 32 0 10 5 18 10 18 6 0 10 8 10 18 0 10
9 24 20 32 11 8 20 21 20 28 0 7 18 31 40 52 22 21 40 43 40 49 0 15 146 161
161 161 6 0 24 14 39 30 15 17 34 30 42 30 7 0 20 9 28 20 8 11 22 20 32 20
10 0 18 5 18 10 0 6 8 10 18 10 10 0 24 9 32 20 8 11 22 20 32 20 10 0 18 5
18 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 9
10 20 10 11 0 20 5 20 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 18 10 40 10 22
0 40 5 40 10 0 6 18 10 40 10 22 0 40 5 40 10 0 6 30 10 70 10 40 0 70 4 70
10 0 7 287 10 840 10 l840 0 0 -990z" />
      </g>
    </svg>
  );
}

/** Variante naranja de marca — `--brand` (#FA6900). Uso por defecto. */
export function IsotipoNaranja(props: SVGProps<SVGSVGElement>) {
  return <Isotipo fill="#FA6900" {...props} />;
}

/** Variante blanca — lockups sobre fondo oscuro o superficies de marca. */
export function IsotipoBlanco(props: SVGProps<SVGSVGElement>) {
  return <Isotipo fill="#FFFFFF" {...props} />;
}

/** Variante negra — lockups sobre fondo claro donde el naranja no aplica. */
export function IsotipoNegro(props: SVGProps<SVGSVGElement>) {
  return <Isotipo fill="#17181B" {...props} />;
}
